import React from 'react';

const Lrn_us_sci = () => {
  return (
    <div>
      
    </div>
  );
}

export default Lrn_us_sci;
